import { create } from 'zustand';

export const useUsersStore = create((set) => ({
  selectedUser: null,
  setUserData: (user) => set(() => ({ selectedUser: user })),
  deleteUserData: () => set(() => ({ selectedUser: null })),
}));
